var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import matchSorter from 'match-sorter';
import { isEmpty } from 'lodash';
import Input from '@material-ui/core/OutlinedInput';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { colors } from '../UI-helpers/colors';
import { debounce } from 'lodash';
import './style.css';
var TableSearchContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 8px;\n  ", ";\n"], ["\n  margin: 0 8px;\n  ", ";\n"])), function (props) {
    return props.noMargin && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin: 0;\n    "], ["\n      margin: 0;\n    "])));
});
var getTheme = function (dark, height) {
    return createTheme({
        overrides: {
            MuiOutlinedInput: {
                input: {
                    padding: '8 !important',
                },
                root: {
                    borderRadius: 4,
                    color: "".concat(dark ? colors.appexFontDefault : colors.white, " !important"),
                    width: 250,
                    height: "".concat(height ? height : 35, "px"),
                    '& $notchedOutline': {
                        border: "1px solid ".concat(dark ? colors.smoke : colors.white),
                    },
                    '&:hover $notchedOutline': {
                        border: "1px solid ".concat(dark ? colors.smoke : colors.white, " !important"),
                    },
                    '&$focused $notchedOutline': {
                        border: "1px solid ".concat(dark ? colors.smoke : colors.white, " !important"),
                    },
                },
            },
        },
    });
};
var Search = function (props) {
    var _a = useState(''), searchString = _a[0], setSearchValue = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var theme = useMemo(function () { return getTheme(props === null || props === void 0 ? void 0 : props.dark, props === null || props === void 0 ? void 0 : props.height); }, [props === null || props === void 0 ? void 0 : props.dark, props === null || props === void 0 ? void 0 : props.height]);
    var handleSearch = useRef(debounce(function (value) {
        props.onChangeFilter(value);
        setLoading(false);
    }, 500)).current;
    useEffect(function () {
        return function () {
            handleSearch.cancel();
        };
    }, [handleSearch]);
    if (props.type === 'TABLE') {
        return (_jsx(TableSearchContainer, __assign({ noMargin: props.noMargin }, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(Input, { onChange: function (e) {
                        setLoading(true);
                        handleSearch(e.target.value || undefined); // Set undefined to remove the filter entirely
                    }, placeholder: props.placeholder || 'Search table', startAdornment: loading ? (_jsx(FontAwesomeIcon, { color: (props === null || props === void 0 ? void 0 : props.dark) ? colors.smoke : colors.white, size: "sm", icon: faSpinner, spin: true, style: { marginRight: 8 } })) : (_jsx(FontAwesomeIcon, { color: (props === null || props === void 0 ? void 0 : props.dark) ? colors.smoke : colors.white, size: "sm", icon: faSearch, style: { marginRight: 8 } })), labelWidth: 0 }) })) })));
    }
    if (props.type === 'OTHER') {
        if (!isEmpty(props.data)) {
            return (_jsx("input", { value: searchString || '', onChange: function (e) {
                    var filteredData = matchSorter(props.data, e.target.value, {
                        keys: __spreadArray([], props.searchableKeys, true),
                    });
                    setSearchValue(e.target.value);
                    props.getFilteredData(filteredData);
                }, placeholder: "".concat(props.data.length, " records..."), style: {
                    fontSize: '1.1rem',
                    border: '0',
                } }));
        }
    }
    return _jsx(_Fragment, {});
};
export default Search;
var templateObject_1, templateObject_2;
